import { useState } from 'react';
import { crmTypeLabels } from './crm-config';
import { CrmIntegrationCard } from './crm-integration-card';
import { useCrmIntegrationActions } from './crm-integration-actions';
import { PlatformConfigForm } from './platform-config-form';
import { isPlatformConfigComplete, parsePlatformConfig, platformConfigForSave } from './platform-config';

export function PlatformCrmPanel({
  organizationId,
  integration,
}: {
  organizationId: string;
  integration: { id: string; name: string; config: unknown };
}) {
  const [name, setName] = useState(integration.name);
  const [config, setConfig] = useState(parsePlatformConfig(integration.config));
  const { error, isSaving, isRemoving, save, remove } = useCrmIntegrationActions(organizationId, integration.id);

  return (
    <CrmIntegrationCard
      typeLabel={crmTypeLabels.platform}
      name={name}
      onNameChange={setName}
      error={error}
      isSaving={isSaving}
      isRemoving={isRemoving}
      canSave={isPlatformConfigComplete(config)}
      onSave={() => void save(name, platformConfigForSave(config))}
      onRemove={() => void remove()}
    >
      <PlatformConfigForm config={config} onConfigChange={setConfig} />
    </CrmIntegrationCard>
  );
}
